import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as styles from './Container.styles.scss'

const Container = ({ children, className }) => (
  <div className={classNames(styles.el, className)}>{children}</div>
)

Container.defaultProps = {
  children: undefined,
  className: undefined,
}

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export { Container }
